export class Heap<T> {
  heap: T[];
  compareFn: (a: T, b: T) => number;

  constructor(
    /**
     * 오름차순 정렬
     * negative: a < b
     * 0 : a = b
     * positive: a > b
     */
    compareFn: (a: T, b: T) => number,
  ) {
    this.heap = [];
    this.compareFn = compareFn;
  }

  push(item: T) {
    this.heap.push(item);
    this._bubbleUp();
  }

  pop(): T | null {
    if (this.size() === 0) {
      return null;
    }
    const top = this.heap[0];
    const last = this.heap.pop() as T;
    if (this.size() > 0) {
      this.heap[0] = last;
      this._bubbleDown();
    }
    return top;
  }

  top(): T | null {
    if (this.size() === 0) {
      return null;
    }
    return this.heap[0];
  }

  _bubbleUp(): void {
    let idx = this.heap.length - 1;
    const item = this.heap[idx];
    while (idx > 0) {
      const parentIdx = Math.floor((idx - 1) / 2);
      if (this.compareFn(this.heap[parentIdx], item) <= 0) {
        break;
      }
      this.heap[idx] = this.heap[parentIdx];
      idx = parentIdx;
    }
    this.heap[idx] = item;
  }

  _bubbleDown() {
    let idx = 0;
    const length = this.heap.length;
    const item = this.heap[0];

    while (true) {
      const left = 2 * idx + 1;
      const right = 2 * idx + 2;
      let smallest = idx;

      if (
        left < length &&
        this.compareFn(this.heap[left], this.heap[smallest]) < 0
      ) {
        smallest = left;
      }
      if (
        right < length &&
        this.compareFn(this.heap[right], this.heap[smallest]) < 0
      ) {
        smallest = right;
      }
      if (smallest === idx) {
        break;
      }
      this.heap[idx] = this.heap[smallest];
      idx = smallest;
    }

    this.heap[idx] = item;
  }

  size() {
    return this.heap.length;
  }
}
